import { LatLng } from "leaflet";
import {Data, DeviceData, PayloadData} from "./ELTRES_cmnDefine";
import { getAllPayloadsDate } from "./ELTRES_cmnFunc";

export type DeviceDataEx = DeviceData & {
    presenter?: any
}

export class Pin {
    position: LatLng;
    name: string;
    devId: number;
    dateTime: string;
    rssi: number;
    visible: boolean;
    color: string;
    initialColor: string;
    presenter?: PayloadPresenter;
    constructor(position: LatLng, name: string, devId: number, dateTime: string,
        rssi: number, visible: boolean, color: string, initialColor: string,
        presenter?: PayloadPresenter
    ) {
        this.position = position;
        this.name = name;
        this.devId = devId;
        this.dateTime = dateTime;
        this.rssi = rssi;
        this.visible = visible;
        this.color = color;
        this.initialColor = initialColor;
        this.presenter = presenter;
    }
    getPopupMessage(): string {
        return `デバイス：${this.name} <br />
         日付：${this.dateTime} <br />
         緯度：${this.position.lat} <br />
         経度：${this.position.lng} <br />
         RSSI：${this.rssi}`;
    }
};

export type PayloadPresenter = PayloadData & {
    module?: any;
};

export type Presentation = {
    newPin: (data: Data, device: DeviceDataEx) => Pin;
    convertToCSV?: (data: Data[]) => string;
};

export const mergePresenter = async (devices: DeviceData[]) => {
    let payloadData = await getAllPayloadsDate();
    let payloadDefs = (await Promise.all(payloadData.map(async (p: PayloadData) => {
        let mod = undefined;
        try {
            mod = await import(`./payload/${p.payload_name}`);
        } catch (e) {
        }
        return {...p, module: mod};
    }))).filter(Boolean);
    return devices.map((d: DeviceData) => {
        return {...d, presenter: payloadDefs.find((p: PayloadData) => p.payload_id === d.payload_id)};
    });
};
